import React from "react";
import { ChromePicker } from "react-color";
import PropTypes from "prop-types";

const ColorSettings = ({ colors, setColors, t_controls }) => {

  const handleChangeCompleteMainColor = (color) => {
    let root = document.documentElement;
    setColors((prevColors) => ({
      ...prevColors,
      main_color: color.hex,
    }));
    root.style.setProperty("--main-color", color.hex);
  };
  
  const handleChangeCompleteSecondColor = (color) => {
    let root = document.documentElement;
    setColors((prevColors) => ({
      ...prevColors,
      second_color: color.hex,
    }));
    root.style.setProperty("--alt-color", color.hex);
  };

  return (
    <div className="row mb-3" style={{ color: "black" }}>
      <span className="col-lg-6">
        <h5>{t_controls.main_color}</h5>
        <ChromePicker
          color={colors.main_color}
          onChangeComplete={handleChangeCompleteMainColor}
        />
      </span>
      <span className="col-lg-6">
        <h5>{t_controls.secondary_color}</h5>
        <ChromePicker
          color={colors.second_color}
          onChangeComplete={handleChangeCompleteSecondColor}
        />
      </span>
    </div>
  );
};

ColorSettings.propTypes = {
  colors: PropTypes.object.isRequired,
  setColors: PropTypes.func.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default ColorSettings;
